import { AD, EP, GLOBAL_CONTEXT, USER_TYPE_COOKIE_NAME } from "mmbclient/Common/CommonVariable";
import { useContext, useEffect, useLayoutEffect } from "react";
import './ConsignmentDetail.css';
import DatePicker from "react-datepicker";
import ConsignmentDetailController from "mmbclient/Reports/ConsignmentDetailController";
import CircularSpinner from "mmbclient/Components/CircularSpinner";
import { getCookie, formatDate } from "mmbclient/Common/CommonFunctions";
import { RenderPagination } from "mmbclient/Components/RenderPagination";

export const ConsignmentDetail = () => {

    const store = useContext(GLOBAL_CONTEXT);

    const { searchTerm, setSearchTerm, setCurrentPage, currentItems, currentPage, totalPages, itemsPerPage, clientOption, client, setClient, loading, startDate, setStartDate, endDate, setEndDate, option, setOption, status, setStatus, betterLoggerFunction, handleSearch, handlePrint, exportToCSV, exportToExcel, setItemPerPage, handleEnterAsTab,startDateRef, endDateRef, handlePrintPOD,selectPrintDockerCount,printAllSelectDocket,setCheckPrintDocketPrintList,checkedPrintDocketList, selectAllDocketToPrint, isSelectAllDockerChecked,changePage } = ConsignmentDetailController(store);

    return (
        <>
            <div onMouseOver={betterLoggerFunction}>
                {loading && <CircularSpinner />}
                {/* Body Content */}
                <div className="container mt-2" style={{maxWidth:"1400px"}}>
                    <div className="text-center">
                        <h1 style={{fontSize:'20px'}}>Booking Detail</h1>
                    </div>
                    <hr class="my-2" />
                    <form onKeyDown={handleEnterAsTab}>
                        <div className="row mb-2">
                            {
                                (getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP) ?
                                    <>
                                        <div className="col-md-3">
                                            <label className="form-label small-label" >Client</label>
                                            <select
                                                className="form-select small-input"
                                                value={client}
                                                onChange={(e) => setClient(e.target.value)}
                                            >
                                                {clientOption.map((option, index) => (
                                                    <option key={index} value={option}>
                                                        {option}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </> : null
                            }
                            <div className="col-md-2">
                                <label className="form-label small-label">From Date</label>
                                <DatePicker
                                    selected={startDate}
                                    onChange={(date) => setStartDate(date)}
                                    className="form-control small-input"
                                    dateFormat="dd/MM/yyyy"
                                    name="startDate"
                                    ref={startDateRef}
                                />
                            </div>
                            <div className="col-md-2">
                                <label className="form-label small-label">To Date</label>
                                <DatePicker
                                    selected={endDate}
                                    onChange={(date) => setEndDate(date)}
                                    className="form-control small-input"
                                    dateFormat="dd/MM/yyyy"
                                    name="endDate"
                                    ref={endDateRef}
                                />
                            </div>
                            <div className="col-md-2">
                                <label className="form-label small-label">Dom/Int</label>
                                <select
                                    className="form-select small-input"
                                    value={option}
                                    onChange={(e) => setOption(e.target.value)}
                                >
                                    <option value="Both">Both</option>
                                    <option value="Domestic">Domestic</option>
                                    <option value="International">International</option>
                                </select>
                            </div>
                            <div className="col-md-2">
                                <label className="form-label small-label">Status</label>
                                <select
                                    className="form-select small-input"
                                    value={status}
                                    onChange={(e) => setStatus(e.target.value)}
                                >
                                    <option value="Both">Both</option>
                                    <option value="Delivered">Delivered</option>
                                    <option value="Undelivered">Undelivered</option>
                                </select>
                            </div>
                            <div className="col-md-1 d-flex align-items-end">
                                <button className="btn btn-primary mt-2 small-input" name="saveBtn"
                                    onClick={
                                        (e) => {
                                            setCurrentPage(1); // Reset to first page on search
                                            handleSearch(e);
                                        }
                                    }>
                                    Search
                                </button>
                            </div>
                            <div className="col-md-1 d-flex align-items-end mt-2">
                                {/* <label for="itemPerPage" className="form-label">Choose data:</label> */}
                                <select name="itemPerPage" id="item"
                                onChange={(e) => {
                                    setItemPerPage(e.target.value)
                                    console.log(e.target.value)
                                }
                                }>
                                    <option value="20">20</option>
                                    <option value="40">40</option>
                                    <option value="70">70</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                            {/* <div class="col-md-1 d-flex align-items-end">
                                <div>
                                    <label class="small-label">Select all</label>
                                    <input type="checkbox" checked={isSelectAllDockerChecked} onChange={selectAllDocketToPrint}/>
                                </div>
                            </div> */}
                            <div class="col-md-1 d-flex align-items-end mt-2">
                                <button class="btn btn-primary small-label" onClick={printAllSelectDocket}>Print</button>
                            </div>
                        </div>
                    </form>

                    {/* Export Buttons */}
                    <hr class="my-2" />
                    <div className="mb-3 d-flex align-items-center">
                        <input
                            type="text"
                            placeholder="Search..."
                            className="form-control me-2 flex-grow-1 small-input"
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setCurrentPage(1); // Reset to first page on search
                            }}
                        />
                        <div className="dropdown">
                            <button
                                className="btn btn-primary dropdown-toggle small-label"
                                type="button"
                                id="dropdownMenuButton"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                Export
                            </button>
                            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
                                <li>
                                    <button className="dropdown-item small-label" onClick={exportToCSV}>
                                        Export to CSV
                                    </button>
                                </li>
                                <li>
                                    <button className="dropdown-item small-label" onClick={exportToExcel}>
                                        Export to Excel
                                    </button>
                                </li>
                            </ul>
                        </div>

                        {/* <div class="dropdown">
                            <button class="btn btn-primary small-label" name="saveBtn" onClick={printAllSelectDocket}>Search</button>
                        </div> */}
                    </div>

                    {/* Data Table */}
                    <div className="table-responsive">
                        <table className="table table-bordered table-striped small-label" style={{verticalAlign: 'middle',lineHeight: "1"}}>
                            <thead>
                                <tr>
                                    <th >SNo</th>
                                    {
                                        (getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP) ? <>
                                            <th>Client</th>
                                        </> : null
                                    }
                                    <th>Date</th>
                                    <th>Awb No</th>
                                    <th>Fwd No/Ref No</th>
                                    <th>Origin</th>
                                    <th>Destination</th>
                                    <th>Pcs</th>
                                    <th>Network</th>
                                    <th>Type</th>
                                    <th>Sender</th>
                                    <th>Receiver</th>
                                    <th>Status</th>
                                    <th>Remarks</th>
                                    <th>Docket</th>
                                    <th>
                                        <div className="d-flex flex-row gap-2">
                                            <span class="small-label">Select</span>
                                            <input type="checkbox" checked={isSelectAllDockerChecked} onChange={selectAllDocketToPrint}/>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems.length > 0 ? (
                                    currentItems.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                                            {
                                                (getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP) ? <>
                                                    <td>{item.client_name}</td>
                                                </> : null
                                            }
                                            <td style={{minWidth:"90px"}}>{formatDate(item.booking_date)}</td>
                                            <td>{item.awb_no}</td>
                                            <td>{item.forwarding_no}</td>
                                            <td>{item.origin_city}</td>
                                            <td>{item.city_name}</td>
                                            <td>{item.packets}</td>
                                            <td>{item.network}</td>
                                            <td>{item.document_type === 'D' ? 'Dox' : 'NDox'}</td>
                                            <td>{item.consignor_phone}</td>
                                            <td>{item.consignee_phone}</td>
                                            <td>{item.delivery_status}</td>
                                            <td>{item.remarks}</td>
                                            {/* <td>{
                                                <div className="row mb-1 align-items-center">
                                                <div className="col-md-2">
                                                    <a 
                                                        href="javascript:void(0)" 
                                                        onClick={()=>handlePrint(item.awb_no)} 
                                                        className="mt-1 d-block" 
                                                        style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}>
                                                            print
                                                    </a> 
                                                </div>
                                                {item.pod?
                                                <div className="col-md-2">
                                                    <a 
                                                        href="javascript:void(0)" 
                                                        onClick={()=>handlePrintPOD(item.pod)} 
                                                        className="mt-1 d-block" 
                                                        style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}>
                                                            pod
                                                    </a> 
                                                </div>:null}
                                            </div>}
                                            </td> */}

                                            <td>
                                                <div className="d-flex flex-row gap-2">
                                                    <span 
                                                        onClick={()=>handlePrint(item.awb_no)} 
                                                        style={{cursor:"pointer", color:"blue", textDecoration:"underline",marginBottom:"3px"}}
                                                    >
                                                        Print
                                                    </span>

                                                    {item.pod && (
                                                        <span 
                                                            onClick={()=>handlePrintPOD(item.pod)} 
                                                            style={{cursor:"pointer", color:"green", textDecoration:"underline"}}
                                                        >
                                                            POD
                                                        </span>
                                                    )}
                                                </div>
                                            </td>
                                            <td><input type="checkbox" name="" 
                                            value={item.awb_no}
                                            checked={checkedPrintDocketList.includes(item.awb_no)}
                                            onChange={selectPrintDockerCount}/></td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="16" className="text-center">No results found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <nav aria-label="Page navigation">
                            <ul className="pagination justify-content-center">
                                <RenderPagination currentPage={currentPage} setCurrentPage={changePage} totalPages={totalPages}/>
                            </ul>
                        </nav>
                    </div>
                </div>

                {/* Footer */}
                {/* <footer className="bg-light text-center py-3">
                <div className="container">
                    <span>© 2024 My Application. All Rights Reserved.</span>
                </div>
                </footer> */}
            </div >
        </>
    );

}